import styled, { css } from 'styled-components';
import type { TextStyledProps } from './Text.types';
import {
  BreakpointsOptional,
  BreakpointValue,
  forEachBreakpoint,
  TextSizes,
  TextSizeValue,
} from 'styled-system';

const Text = styled.p<TextStyledProps>((props) => {
  const { size, weight, color, inline, align } = props;

  const colorValue = color ?? 'inherit';
  const textSizes: TextSizes = props.theme.components.text.sizes;
  const breakpoints = props.theme.breakpoints;
  const getFontSize = () => {
    let styles = '';

    function StylesByBreakpoint(
      breakpoint: BreakpointValue,
      textSizeValues: [string, string],
    ) {
      styles += `@media only screen and (min-width: ${breakpoints[breakpoint]}px) {
      font-size: ${textSizeValues?.[0]};
    }`;
    }

    // TODO: tidy up below check with type predicate
    if (typeof size !== 'string') {
      forEachBreakpoint((breakpoint) => {
        const sizeTyped = size as BreakpointsOptional<TextSizeValue>;
        if (sizeTyped[breakpoint]) {
          const textObjectKey = sizeTyped[breakpoint] as TextSizeValue;
          const textSizeValues = textSizes[textObjectKey]; // ['32px', '48px'] fontAndLineHeightValues

          StylesByBreakpoint(breakpoint, textSizeValues);
        }
      });
    } else {
      //  font size will continue to be populated by raw string values as well i.e. 'm', 'l', 'xl'
      const [fontSizeValue, lineHeightValue] = textSizes[size];
      styles += `
        font-size: ${fontSizeValue};
        line-height: ${lineHeightValue};
      `;
    }
    return css`
      ${styles}
    `;
  };
  return css`
    display: ${inline ? 'inline-block' : 'block'};
    color: ${colorValue};
    font-weight: ${(props) => props.theme.typography.fontWeights[weight]};
    ${align &&
    css`
      text-align: ${align};
    `}
    ${getFontSize}
  `;
});

export { Text };
